<template>
    <div class="discuss-list-page">
        <!-- 1、顶部菜单栏 -->
        <div class="discuss-title-bar-normal dsp-flex">
            <div class="title-side title-gray detail-title-left">
                <span v-if="fromEmbedded" class="discuss-title-back" @click="clickClose">
                    <i class="iconfont icon-guanbi"></i>
                </span>
                <span v-else class="title-back discuss-title-back" @click="clickBack">
                    <i class="iconfont icon-xiangzuo"></i>
                </span>
            </div>
            <div class="title-middle">
                <span v-show="detailInfo.f_name" v-bind:class="{'title-word-small': detailInfo.f_name && detailInfo.f_name.length > 6 && detailInfo.f_name.length <= 10, 'title-word-smallest' : detailInfo.f_name && detailInfo.f_name.length > 10}">{{detailInfo.f_name}} {{detailInfo.sex == 0 ? '男' : '女'}}</span>
            </div>
            <div class="title-side title-right detail-title-right">
            </div>
        </div>
        <!-- 2、论盘记录列表 -->
        <div class="discuss-list" v-if="lunpanList.length > 0">
            <discuss-list-item v-for="lunpanData of lunpanList"
                v-bind:key="'lunpan-item' + lunpanData.id + Math.random(0, 10)"
                v-bind:discussData="lunpanData"
                v-bind:itemFunc="clickLunPanItem"
                v-bind:editFunc="clickLunPanEdit"
                v-bind:deleteFunc="clickLunPanDelete">
            </discuss-list-item>
        </div>
        <no-data
            v-else
            v-bind:noteText="'记录空空如也~'">
        </no-data>

        <!-- 3、发起在线论盘 -->
        <div class="discuss-bottom-bar" @click="clickDiscuss">
            <span class="discuss-span-chat"><i class="iconfont icon-chat"></i>发起在线论盘</span>
        </div>

        <!-- 4、弹框:修改论盘名称 -->
        <van-dialog v-model="showPop" v-bind:title="'修改论盘名称'" v-bind:before-close="beforeClose" show-cancel-button closeOnClickOverlay>
            <div class="create-group-input">
                <input type="text" placeholder="请输入论盘名称" v-model="inputLunPanName" maxlength="25" autofocus />
            </div>
        </van-dialog>
    </div>
</template>

<script>
import NoData from '../../components/common/NoData.vue'
import DiscussListItem from '../../layouts/discuss/DiscussListItem.vue'
import { DISCUSS_DATA_MANAGER, DATA } from '../../modules/data';
import { WS } from '../../modules/websocket'
import { SHARE } from '../../modules/share';
import { DISCUSS_DOM } from '../../modules/dom';
import { SCHEME } from '../../modules/utils';
export default {
    name: 'DiscussList',
    components: { NoData, DiscussListItem },
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        detailInfo() {
            return this.$store.state.discuss.detailInfo;
        },
        lunpanList() {
            return this.$store.state.discuss.lunpanList;
        }
    },
    data() {
        return {
            showPop: false,
            inputLunPanName: '',
            curEditData: {}
        }
    },
    created: function() {
        var curPath = this.$router.history.current.path;
        // console.log('DiscussList--------created', this.detailInfo)
        if(curPath.indexOf('/embedded/discusslist') == -1 && !this.detailInfo.id) {
            this.$router.replace('/record');
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.height = (innerHeight - 52) + 'px';
        },
        clickClose() {
            SCHEME.closeWebView();
            this.$store.dispatch('embedded/resetData');
        },
        clickBack() {
            // 返回排盘页
            this.$router.replace('/detail/record/' + this.detailInfo.id);
            this.$store.dispatch("discuss/resetData");
            this.$store.dispatch("discuss/resetLunPanData");
            setTimeout(() => {
                SHARE.initConfigShare();
            }, 10);
        },
        clickLunPanItem(data) {
            console.log('clickLunPanItem', this.detailInfo, data.rid)
            // 初始化论盘数据:聊天记录列表
            this.goToDiscussPage(data);
        },
        clickLunPanEdit(data) {
            this.showPop = true;
            this.curEditData = data;
            this.inputLunPanName = data.title;
        },
        clickLunPanDelete(deleteId) {
            this.$store.dispatch('discuss/deleteLunPanData', deleteId);
        },
        /**
         * 发起论盘::直接默认名称发起论盘，并进入该论盘
         */
        clickDiscuss() {
            var me = this,
                newTitle = DISCUSS_DATA_MANAGER.getNewLunPanTitle();
            this.$store.dispatch('discuss/addNewLunPan', {
                lunpanName: newTitle,
                cb: function(data){
                    setTimeout(() => {
                        me.goToDiscussPage(data);
                    }, 100);
                }
            });
        },
        goToDiscussPage(data) {
            var me = this;
            // 先重置，再初始化mini命盘的数据
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', this.detailInfo);
            // 跳转到论盘详情页面
            this.$router.replace('/discuss/discusslist/' + this.detailInfo.id);
            // 初始化IM
            WS.initWebSocket(data.rid, function(){
                // 初始化论盘数据:聊天记录列表:websocket登录之后再拉取列表数据
                me.$store.dispatch("discuss/initLunPan", {
                    lunpanData: data,
                    cb: function() {
                        // 设置微信分享配置
                        setTimeout(() => {
                            DISCUSS_DOM.updateDiscussPageStyle();
                            DISCUSS_DOM.updateDiscussFormStyle();
                        }, 200);
                    }
                });
            });
            
            this.$store.state.discuss.lunpanData = data;
            // 配置微信分享
            setTimeout(() => {
                if(!me.fromEmbedded){
                    SHARE.initConfigShare();
                }
            }, 20);
        },
        beforeClose(action, done) {
            window.scrollTo(0, 0);
            var me = this;
            if (action === 'confirm') {
                if(this.inputLunPanName != ''){
                    // 名称不为空
                    if(this.inputLunPanName == this.curEditData.title){
                        this.$toast("名称未改变");
                        done();
                        return;
                    }
                    this.$store.dispatch('discuss/editLunPanData', {
                        id: this.curEditData.id,
                        f_title: this.inputLunPanName,
                        cb: function(){
                            me.$toast("修改论盘名称成功");
                        }
                    })
                    done();
                }else {
                    this.$toast("名称不能为空");
                    done();
                }
            } else {
                done();
            }
        }
    }
}
</script>